import { render, staticRenderFns } from "./polygon8.vue?vue&type=template&id=1f3d845e&"
import script from "./polygon8.vue?vue&type=script&lang=ts&"
export * from "./polygon8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports